import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { FileUpload } from "@/components/FileUpload";
import { CoverImage } from "@/components/CoverImage";
import { ArtistList, artistDisplay } from "./ArtistList";
import { Field, SimpleSelect } from "./Field";
import { RELEASE_TYPES, GENRES, LANGUAGES } from "@/constants/catalog";
import { t } from "@/i18n";

export const StepMetadata = ({ rel, set }) => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
    <div className="lg:col-span-4 space-y-4">
      <CoverImage fileId={rel.cover_file_id} className="w-full aspect-square" />
      <FileUpload kind="cover" accept="image/jpeg,image/png" label={t("Portada (cualquier tamaño · se ajusta a 3000×3000)")} value={rel.cover_file_id} filename={rel.cover_filename}
        onUploaded={(f) => set({ cover_file_id: f.id, cover_filename: f.original_filename })} onClear={() => set({ cover_file_id: null, cover_filename: null })} testId="upload-cover" compact />
      <FileUpload kind="contract" accept="application/pdf" label={t("Contrato / licencia (PDF)")} value={rel.contract_file_id} filename={rel.contract_filename}
        onUploaded={(f) => set({ contract_file_id: f.id, contract_filename: f.original_filename })} onClear={() => set({ contract_file_id: null, contract_filename: null })} testId="upload-contract" compact />
    </div>
    <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="Título del álbum / single" className="sm:col-span-2">
        <Input value={rel.title} onChange={(e) => set({ title: e.target.value })} placeholder={t("Ej. Noche Eterna")} data-testid="input-album-title" />
      </Field>
      <Field label="Artistas principales" hint="Hasta 5. Escribe el nombre: aparecerán perfiles del directorio. Con el icono «+» puedes crear su perfil con los datos que pide la distribuidora.">
        <ArtistList items={rel.primary_artists} onChange={(primary_artists) => set({ primary_artists })} testId="primary-artists" addLabel="Agregar artista principal" />
      </Field>
      <Field label="Artistas invitados (feat.)" hint="Opcional. Aparecerán como «feat.» en el lanzamiento y en cada track.">
        <ArtistList items={rel.featured_artists} onChange={(featured_artists) => set({ featured_artists })} testId="featured-artists" addLabel="Agregar artista invitado" />
      </Field>
      {artistDisplay(rel.primary_artists, rel.featured_artists) && (
        <p className="sm:col-span-2 -mt-2 text-sm text-muted-foreground" data-testid="artist-display-preview">{t("Se mostrará como:")} <span className="text-foreground font-medium">{artistDisplay(rel.primary_artists, rel.featured_artists)}</span></p>
      )}
      <Field label="Tipo de lanzamiento">
        <SimpleSelect value={rel.release_type} onChange={(v) => set({ release_type: v })} options={RELEASE_TYPES} testId="select-release-type" />
      </Field>
      <Field label="Género principal">
        <SimpleSelect value={rel.primary_genre} onChange={(v) => set({ primary_genre: v })} options={GENRES} testId="input-primary-genre" />
      </Field>
      <Field label="Género secundario">
        <SimpleSelect value={rel.secondary_genre} onChange={(v) => set({ secondary_genre: v })} options={GENRES} testId="select-secondary-genre" />
      </Field>
      <Field label="Sello">
        <Input value={rel.label} onChange={(e) => set({ label: e.target.value })} data-testid="input-label" />
      </Field>
      <Field label="Idioma de metadata">
        <SimpleSelect value={rel.language} onChange={(v) => set({ language: v })} options={LANGUAGES} testId="select-language" />
      </Field>
      <Field label="Live date (fecha de publicación)">
        <Input type="date" value={rel.live_date || ""} onChange={(e) => set({ live_date: e.target.value })} data-testid="input-live-date" />
      </Field>
      <Field label="Fecha original de lanzamiento" hint="Solo si es re-lanzamiento">
        <Input type="date" value={rel.original_release_date || ""} onChange={(e) => set({ original_release_date: e.target.value })} data-testid="input-original-date" />
      </Field>
      <Field label="UPC" hint="Déjalo vacío para asignarlo automáticamente">
        <Input value={rel.upc || ""} onChange={(e) => set({ upc: e.target.value })} placeholder="840123456789" className="font-mono" data-testid="input-upc" />
      </Field>
      <Field label="Año de copyright">
        <Input type="number" value={rel.copyright_year || ""} onChange={(e) => set({ copyright_year: e.target.value ? Number(e.target.value) : null })} placeholder="2026" data-testid="input-copyright-year" />
      </Field>
      <Field label="℗ P-Line">
        <Input value={rel.p_line || ""} onChange={(e) => set({ p_line: e.target.value })} placeholder="2026 Doble R Records" data-testid="input-p-line" />
      </Field>
      <Field label="© C-Line">
        <Input value={rel.c_line || ""} onChange={(e) => set({ c_line: e.target.value })} placeholder="2026 Doble R Records" data-testid="input-c-line" />
      </Field>
      <Field label="Notas internas" className="sm:col-span-2">
        <Textarea value={rel.notes || ""} onChange={(e) => set({ notes: e.target.value })} rows={2} data-testid="input-notes" />
      </Field>
    </div>
  </div>
);
